import { getSearchParams } from '@wix/package-picker-shared';
import { useCurrentModule } from '../../components/ModuleProvider';
import { EclipsePackagePickerSteps } from '../../types/types';
import { eclipseServerData } from '../../utils';
import { getFreeDomainTooltipKey as getFreeDomainTooltipKeyUtil } from '../../utils/freeDomainTooltipKey';
export let DomainIntentType = /*#__PURE__*/function (DomainIntentType) {
  DomainIntentType["CONNECT"] = "connect";
  DomainIntentType["CONNECT_DROPSHIPPING"] = "connect-dropshipping";
  DomainIntentType["PURCHASE"] = "purchase";
  DomainIntentType["PURCHASE_DROPSHIPPING"] = "purchase-dropshipping";
  DomainIntentType["PURCHASE_STOREFRONT"] = "purchase-storefront";
  DomainIntentType["PURCHASE_FUNNEL"] = "purchase-funnel";
  return DomainIntentType;
}({});
const DOMAIN_INTENT_REFERRAL_VALUES = {
  [DomainIntentType.CONNECT]: 'add-domain-connect-intent',
  [DomainIntentType.CONNECT_DROPSHIPPING]: 'add-domain-connect-intent-dropshipping',
  [DomainIntentType.PURCHASE]: 'add-domain-purchase-intent',
  [DomainIntentType.PURCHASE_DROPSHIPPING]: 'add-domain-purchase-intent-dropshipping',
  [DomainIntentType.PURCHASE_STOREFRONT]: 'add-domain-purchase-intent-storefront',
  [DomainIntentType.PURCHASE_FUNNEL]: 'add-domain-purchase-intent-funnel'
};
const getIntentTypeFromReferral = referralAdditionalInfo => {
  if (!referralAdditionalInfo) {
    return undefined;
  }
  const entry = Object.entries(DOMAIN_INTENT_REFERRAL_VALUES).find(_ref => {
    let [, value] = _ref;
    return value === referralAdditionalInfo;
  });
  return entry ? entry[0] : undefined;
};
export const useDomainIntent = () => {
  const module = useCurrentModule();
  const {
    domainName,
    showDomain: showDomainParam,
    referralAdditionalInfo,
    referrer
  } = getSearchParams();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const isShowDomainExperimentEnabled = experiments.isEnabled('specs.premium.DisplayDomainNameInDomainFeature');
  const intentType = getIntentTypeFromReferral(referralAdditionalInfo);
  const isDomainIntent = intentType !== undefined;
  const isConnectIntent = intentType === DomainIntentType.CONNECT || intentType === DomainIntentType.CONNECT_DROPSHIPPING;
  const isPurchaseIntent = intentType === DomainIntentType.PURCHASE || intentType === DomainIntentType.PURCHASE_DROPSHIPPING || intentType === DomainIntentType.PURCHASE_STOREFRONT || intentType === DomainIntentType.PURCHASE_FUNNEL;
  const showDomain = showDomainParam === true && isShowDomainExperimentEnabled;
  const shouldShowDomainFirst = showDomain && isPurchaseIntent && experiments.isEnabled('specs.premium.domainFirstItemPurchaseIntent');
  const isDisplayDomainNameInTitleEnabled = experiments.isEnabled('specs.premium.displayDomainNameInTitle');
  const currentStep = module.internals.hooks.useCurrentStep();
  const isProductsPage = currentStep === EclipsePackagePickerSteps.SELECT_PLAN || currentStep === EclipsePackagePickerSteps.ANY;
  const shouldShowDomainNameInTitle = intentType === DomainIntentType.PURCHASE && showDomainParam === true && !!domainName && isDisplayDomainNameInTitleEnabled && isProductsPage;
  const isStorefrontReferrerWithDomain = referralAdditionalInfo === DOMAIN_INTENT_REFERRAL_VALUES[DomainIntentType.PURCHASE_STOREFRONT] && showDomainParam === true && referrer === 'storefront';
  const isMatchDomainCycleEnabled = experiments.isEnabled('matchDomainCycleToPremiumCycle');
  const getFreeDomainTooltipKey = featureNameTranslationKey => getFreeDomainTooltipKeyUtil({
    featureNameTranslationKey,
    geo: eclipseServerData.get().geo,
    referralAdditionalInfo,
    domainName,
    isDisplayDomainExperimentEnabled: isShowDomainExperimentEnabled,
    isMatchDomainCycleEnabled
  });
  return {
    isDomainIntent,
    domainName,
    showDomain,
    intentType,
    isConnectIntent,
    isPurchaseIntent,
    shouldShowDomainFirst,
    shouldShowDomainNameInTitle,
    isStorefrontReferrerWithDomain,
    getFreeDomainTooltipKey
  };
};
//# sourceMappingURL=useDomainIntent.js.map